import {BasicScenario} from '../../../allkey/framework/parameters/BasicScenario';

export class AiScenario extends BasicScenario {
apiKey: string;
host: string;
howMany: number;
model: string;
persist: boolean;
persistPrompt: boolean;
size: string;
}

